import _regeneratorRuntime from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var _marked = /*#__PURE__*/_regeneratorRuntime.mark(iterateSiblingListBlocks);
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module list/list/utils/listwalker
 */
import { first as _first, toArray } from 'ckeditor5/src/utils.js';
import { isListItemBlock } from './model.js';
/**
 * Document list blocks iterator.
 */
var ListWalker = /*#__PURE__*/function () {
  /**
   * Creates a document list iterator.
   *
   * @param startElement The start list item block element.
   * @param options.direction The iterating direction.
   * @param options.includeSelf Whether start block should be included in the result (if it's matching other criteria).
   * @param options.sameAttributes Additional attributes that must be the same for each block.
   * @param options.sameIndent Whether blocks with the same indent level as the start block should be included
   * in the result.
   * @param options.lowerIndent Whether blocks with a lower indent level than the start block should be included
   * in the result.
   * @param options.higherIndent Whether blocks with a higher indent level than the start block should be included
   * in the result.
   */
  function ListWalker(startElement, options) {
    _classCallCheck(this, ListWalker);
    this._startElement = startElement;
    this._referenceIndent = startElement.getAttribute('listIndent');
    this._isForward = options.direction == 'forward';
    this._includeSelf = !!options.includeSelf;
    this._sameAttributes = toArray(options.sameAttributes || []);
    this._sameIndent = !!options.sameIndent;
    this._lowerIndent = !!options.lowerIndent;
    this._higherIndent = !!options.higherIndent;
  }
  /**
   * Performs only first step of iteration and returns the result.
   *
   * @param startElement The start list item block element.
   * @param options.direction The iterating direction.
   * @param options.includeSelf Whether start block should be included in the result (if it's matching other criteria).
   * @param options.sameAttributes Additional attributes that must be the same for each block.
   * @param options.sameIndent Whether blocks with the same indent level as the start block should be included
   * in the result.
   * @param options.lowerIndent Whether blocks with a lower indent level than the start block should be included
   * in the result.
   * @param options.higherIndent Whether blocks with a higher indent level than the start block should be included
   * in the result.
   */
  _createClass(ListWalker, [{
    key: Symbol.iterator,
    value:
    /*#__PURE__*/
    /**
     * Iterable interface.
     */
    _regeneratorRuntime.mark(function value() {
      var _this = this;
      var nestedItems, _iterator, _step, _loop, _ret;
      return _regeneratorRuntime.wrap(function value$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              nestedItems = [];
              _iterator = _createForOfIteratorHelper(iterateSiblingListBlocks(this._getStartNode(), this._isForward ? 'forward' : 'backward'));
              _context2.prev = 2;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var node, indent;
                return _regeneratorRuntime.wrap(function _loop$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        node = _step.value.node;
                        indent = node.getAttribute('listIndent'); // Leaving a nested list.
                        if (!(indent < _this._referenceIndent)) {
                          _context.next = 8;
                          break;
                        }
                        if (_this._lowerIndent) {
                          _context.next = 5;
                          break;
                        }
                        return _context.abrupt("return", "break");
                      case 5:
                        // While searching for lower indents, update the reference indent to find another parent in the next step.
                        _this._referenceIndent = indent;
                        _context.next = 25;
                        break;
                      case 8:
                        if (!(indent > _this._referenceIndent)) {
                          _context.next = 16;
                          break;
                        }
                        if (_this._higherIndent) {
                          _context.next = 11;
                          break;
                        }
                        return _context.abrupt("return", "continue");
                      case 11:
                        if (_this._isForward) {
                          _context.next = 14;
                          break;
                        }
                        nestedItems.push(node);
                        return _context.abrupt("return", "continue");
                      case 14:
                        _context.next = 25;
                        break;
                      case 16:
                        if (_this._sameIndent) {
                          _context.next = 23;
                          break;
                        }
                        if (!_this._higherIndent) {
                          _context.next = 22;
                          break;
                        }
                        if (!nestedItems.length) {
                          _context.next = 21;
                          break;
                        }
                        return _context.delegateYield(nestedItems, "t0", 20);
                      case 20:
                        nestedItems.length = 0;
                      case 21:
                        return _context.abrupt("return", "break");
                      case 22:
                        return _context.abrupt("return", "continue");
                      case 23:
                        if (!_this._sameAttributes.some(function (attr) {
                          return node.getAttribute(attr) !== _this._startElement.getAttribute(attr);
                        })) {
                          _context.next = 25;
                          break;
                        }
                        return _context.abrupt("return", "break");
                      case 25:
                        if (!nestedItems.length) {
                          _context.next = 28;
                          break;
                        }
                        return _context.delegateYield(nestedItems, "t1", 27);
                      case 27:
                        nestedItems.length = 0;
                      case 28:
                        _context.next = 30;
                        return node;
                      case 30:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _loop);
              });
              _iterator.s();
            case 5:
              if ((_step = _iterator.n()).done) {
                _context2.next = 14;
                break;
              }
              return _context2.delegateYield(_loop(), "t0", 7);
            case 7:
              _ret = _context2.t0;
              if (!(_ret === "break")) {
                _context2.next = 10;
                break;
              }
              return _context2.abrupt("break", 14);
            case 10:
              if (!(_ret === "continue")) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("continue", 12);
            case 12:
              _context2.next = 5;
              break;
            case 14:
              _context2.next = 19;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t1 = _context2["catch"](2);
              _iterator.e(_context2.t1);
            case 19:
              _context2.prev = 19;
              _iterator.f();
              return _context2.finish(19);
            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, value, this, [[2, 16, 19, 22]]);
    })
    /**
     * Returns the model element to start iterating.
     */
  }, {
    key: "_getStartNode",
    value: function _getStartNode() {
      if (this._includeSelf) {
        return this._startElement;
      }
      return this._isForward ? this._startElement.nextSibling : this._startElement.previousSibling;
    }
  }], [{
    key: "first",
    value: function first(startElement, options) {
      var walker = new this(startElement, options);
      var iterator = walker[Symbol.iterator]();
      return _first(iterator);
    }
  }]);
  return ListWalker;
}();
/**
 * Iterates sibling list blocks starting from the given node.
 *
 * @internal
 * @param node The model node.
 * @param direction Iteration direction.
 * @returns The object with `node` and `previous` {@link module:engine/model/element~Element blocks}.
 */
export { ListWalker as default };
export function iterateSiblingListBlocks(node) {
  var direction,
    isForward,
    previousNodesByIndent,
    previous,
    previousNodeInList,
    nodeIndent,
    previousNodeIndent,
    _args3 = arguments;
  return _regeneratorRuntime.wrap(function iterateSiblingListBlocks$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          direction = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 'forward';
          isForward = direction == 'forward';
          previousNodesByIndent = []; // Last seen nodes of lower indented lists.
          previous = null;
        case 4:
          if (!isListItemBlock(node)) {
            _context3.next = 13;
            break;
          }
          previousNodeInList = null; // It's like `previous` but has the same indent as current node.
          if (previous) {
            nodeIndent = node.getAttribute('listIndent');
            previousNodeIndent = previous.getAttribute('listIndent'); // Let's find previous node for the same indent.
            // We're going to need that when we get back to previous indent.
            if (nodeIndent > previousNodeIndent) {
              previousNodesByIndent[previousNodeIndent] = previous;
            }
            // Restore the one for given indent.
            else if (nodeIndent < previousNodeIndent) {
              previousNodeInList = previousNodesByIndent[nodeIndent];
              previousNodesByIndent.length = nodeIndent;
            }
            // Same indent.
            else {
              previousNodeInList = previous;
            }
          }
          _context3.next = 9;
          return {
            node: node,
            previous: previous,
            previousNodeInList: previousNodeInList
          };
        case 9:
          previous = node;
          node = isForward ? node.nextSibling : node.previousSibling;
          _context3.next = 4;
          break;
        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked);
}
/**
 * The iterable protocol over the list elements.
 *
 * @internal
 */
export var ListBlocksIterable = /*#__PURE__*/function () {
  /**
   * @param listHead The head element of a list.
   */
  function ListBlocksIterable(listHead) {
    _classCallCheck(this, ListBlocksIterable);
    this._listHead = listHead;
  }
  /**
   * List blocks iterator.
   *
   * Iterates over all blocks of a list.
   */
  _createClass(ListBlocksIterable, [{
    key: Symbol.iterator,
    value: function value() {
      return iterateSiblingListBlocks(this._listHead, 'forward');
    }
  }]);
  return ListBlocksIterable;
}();